import { render, staticRenderFns } from "./editBuildingView.vue?vue&type=template&id=e52d8188&scoped=true"
import script from "./editBuildingView.vue?vue&type=script&lang=js"
export * from "./editBuildingView.vue?vue&type=script&lang=js"
import style0 from "./editBuildingView.vue?vue&type=style&index=0&id=e52d8188&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e52d8188",
  null
  
)

export default component.exports